import React from "react";
import BasicList, { classNames } from "../../../../Table/BasicList";
import { useHistory } from "react-router-dom";
import { Text, Stack } from "@fluentui/react";

const DiscoverabilityList = ({ data }) => {
  const history = useHistory();

  const onRenderCell = (item) => {
    return (
      <Stack styles={{ root: { width: 500 } }}>
        <div
          className={classNames.itemCell}
          data-is-focusable={true}
          onClick={() => history.push(item.slug)}
        >
          <div className={classNames.itemContent}>
            <div className={classNames.itemIndex}>
              Checklist Name:
            </div>
            <div className={classNames.itemName}>{item.name}</div>
          </div>
        </div>
      </Stack>
    );
  };

  const mappedData =
    data &&
    Array.isArray(data.checklists) &&
    data.checklists.map((checklist) => ({
      name: checklist && checklist.name,
      id: checklist && checklist.checklistID,
      slug: `/checklist-feature/checklists/${
        (checklist && checklist.checklistID) || ""
      }/wizard`,
    }));

  if (!data.checklists || data.checklists.length === 0) {
    return <Text>This item is not associated with a checklist</Text>;
  }
  return <BasicList items={mappedData} onRenderCell={onRenderCell} />;
};

export default DiscoverabilityList;
